import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'Lot',
        caption: 'Lot',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true,
        allowEditing: false,
        allowSorting: true,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.lg0,
        allowSorting: false,
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        alignment: 'right'
    },
    {
        dataField: 'CostEach',
        caption: 'Cost each',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        format: '#0.00',
        allowSorting: false,
        alignment: 'right'
    },
    {
        dataField: 'Expiry',
        caption: 'Expiry',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        allowSorting: false,
    }
];
